import Archive from '/src/js/Archive';
import CollapsibleSection from '/src/js/CollapsibleSection';
import Events from '/src/js/Events';
import Helpers from '/src/js/Helpers';
import ModalDialog from '/src/js/ModalDialog';
import OnThisPageNavigation from '/src/js/OnThisPageNavigation';
import ResponsiveUIChanges from '/src/js/ResponsiveUIChanges';
import SitewideBanner from '/src/js/SitewideBanner';
import SiteNavigation from '/src/js/SiteNavigation';
import Video from '/src/js/Video';
import CustomEDD from '/src/js/CustomEDD';
import Search from './Search';
import Accessibility from '/src/js/Accessibility';

const helpers = new Helpers();
helpers.init();

const sitewideBanner = new SitewideBanner();
sitewideBanner.init(helpers);

const siteNavigation = new SiteNavigation();
siteNavigation.init(helpers);

const collapsibleSection = new CollapsibleSection();
collapsibleSection.init(helpers);

const responsiveUIChanges = new ResponsiveUIChanges();
responsiveUIChanges.init(helpers, collapsibleSection);

const onThisPageNavigation = new OnThisPageNavigation();
onThisPageNavigation.init(helpers);

const modalDialog = new ModalDialog();
modalDialog.init();

const video = new Video();
video.init(helpers);

const archive = new Archive();
archive.init(helpers);

const edd = new CustomEDD();
edd.init(helpers)

const events = new Events();
events.init(helpers);

const search = new Search();
search.init();

const accessibility = new Accessibility();
accessibility.init();

/*
 * NOTE: most browsers will only allow serviceWorker in SSL mode
 */
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js');
    });
}